import React, { Component } from 'react';
import { Table } from 'antd';
import { connect } from 'react-redux';
import PrintTable from '../../../../../../CommonComponents/PrintTable/PrintTable';
// import {PrintTable} from '../../../../../../CommonComponents/commonStyles';
import formatter from '../../../../../../utils/formatter';
import { milliToDate, dateFormatter, getColumnLength } from '../../../../../../utils/commonUtil';
import { ContentPrinterDerivedStates } from '../../selectors';

export const renderAmount = text => {
	if (text !== '--') {
		return formatter({
			value: text,
			fieldSuffix: 'Dollars',
		});
	} else {
		return text;
	}
};

class ContentPrinter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dataSource: [],
			columns: [],
		};
	}

	componentDidMount() {
		this.setState({ dataSource: [], columns: [] }, () => {
			this.createRowAndColumns(this.props);
		});
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ dataSource: [], columns: [] }, () => {
			this.createRowAndColumns(nextProps);
		});
		if (this.props.printData !== nextProps.printData) {
			this.createRowAndColumns(nextProps);
		}
	}

	createRowAndColumns(props) {
		var dataSource = this.state.dataSource;
		if (props.selectedTabs == '1') {
			props.data &&
				props.data.map(item => {
					var temp = {
						enteredDate: !item.enteredDate ? <>&mdash;</> : milliToDate(item.enteredDate),
						charityName: !item.charityName ? <>&mdash;</> : item.charityName,
						amount: !item.amount ? <>&mdash;</> : renderAmount(item.amount),
						dateRequested: !item.dateRequested ? <>&mdash;</> : milliToDate(item.dateRequested),
						issuedate: !item.issuedate ? <>&mdash;</> : <>{milliToDate(item.issuedate)}</>,
						purpose: !item.purpose ? <>&mdash;</> : <>{item.purpose}</>,
						status: !item.status ? <>&mdash;</> : item.status,
						checkClearedDate:
							!item.checkClearedDate || item.checkClearedDate === 0 ? (
								<>&mdash;</>
							) : (
								milliToDate(item.checkClearedDate)
							),
					};
					dataSource.push(temp);
				});
			this.setState({
				dataSource: dataSource,
				columns: [
					{
						title: 'Entered Date',
						dataIndex: 'enteredDate',
						key: 'enteredDate',
					},
					{
						title: 'Charity Name',
						dataIndex: 'charityName',
						key: 'charityName',
					},
					{
						title: 'Amount',
						dataIndex: 'amount',
						key: 'amount',
					},
					{
						title: 'Scheduled Issue Date',
						dataIndex: 'dateRequested',
						key: 'dateRequested',
					},
					{
						title: 'Issue Date',
						dataIndex: 'issuedate',
						key: 'issuedate',
					},
					{
						title: 'Purpose',
						dataIndex: 'purpose',
						key: 'purpose',
					},
					{
						title: 'Status',
						dataIndex: 'status',
						key: 'status',
					},
					{
						title: 'Check Cleared',
						dataIndex: 'checkClearedDate',
						key: 'checkClearedDate',
					},
				],
			});
		} else if (props.selectedTabs == '2') {
			props.data &&
				props.data.map(item => {
					var temp = {
						enteredDate: !item.enteredDate ? <>&mdash;</> : milliToDate(item.enteredDate),
						charityName: !item.granteeOrg.legalName ? <>&mdash;</> : item.granteeOrg.legalName,
						grantAmount: !item.grantAmount ? <>&mdash;</> : renderAmount(item.grantAmount),
						nextScheduledDate: !item.nextScheduledDate ? <>&mdash;</> : milliToDate(item.nextScheduledDate),
						remainingPayments: !item.remainingPayments ? (
							<>&mdash;</>
						) : (
							<>{item.remainingPayments > 9 ? item.remainingPayments : <>0{item.remainingPayments}</>}</>
						),
						purpose: !item.purpose ? <>&mdash;</> : <>{item.purpose}</>,
						frequency: !item.frequency ? <>&mdash;</> : item.frequency,
						status: !item.status ? <>&mdash;</> : item.status,
					};
					dataSource.push(temp);
				});
			this.setState({
				dataSource: dataSource,
				columns: [
					{
						title: 'Entered',
						dataIndex: 'enteredDate',
						key: 'enteredDate',
					},
					{
						title: 'Charity Name',
						dataIndex: 'charityName',
						key: 'charityName',
					},
					{
						title: 'Amount',
						dataIndex: 'grantAmount',
						key: 'grantAmount',
					},
					{
						title: 'Remaining Payments',
						dataIndex: 'remainingPayments',
						key: 'remainingPayments',
					},
					{
						title: 'Frequency',
						dataIndex: 'frequency',
						key: 'frequency',
					},
					{
						title: 'Status',
						dataIndex: 'status',
						key: 'status',
					},
				],
			});
		} else {
			this.props.agreement &&
				this.props.agreement.map(item => {
					var temp = {
						gaStartDate: !item.gaStartDate ? <>&mdash;</> : dateFormatter(item.gaStartDate),
						gaEndDate: !item.gaEndDate ? <>&mdash;</> : dateFormatter(item.gaEndDate),
						charityName: !item.charityName ? <>&mdash;</> : item.charityName,
						grantAgreementAmount: !item.grantAgreementAmount ? (
							<>&mdash;</>
						) : (
							<>{renderAmount(item.grantAgreementAmount)}</>
						),
						purpose: !item.purpose.description ? <>&mdash;</> : <>{item.purpose.description}</>,
						noOfPayments: !item.noOfPayments ? (
							<>&mdash;</>
						) : (
							<>{item.noOfPayments > 9 ? item.noOfPayments : <>0{item.noOfPayments}</>}</>
						),
						status: !item.status.description ? <>&mdash;</> : item.status.description,
					};
					dataSource.push(temp);
				});
			this.setState({
				dataSource: dataSource,
				columns: [
					{
						title: 'Start Date',
						dataIndex: 'gaStartDate',
						key: 'gaStartDate',
					},
					{
						title: 'End Date',
						dataIndex: 'gaEndDate',
						key: 'gaEndDate',
					},
					{
						title: 'Charity Name',
						dataIndex: 'charityName',
						key: 'charityName',
					},
					{
						title: 'Total Agreement Amount',
						dataIndex: 'grantAgreementAmount',
						key: 'grantAgreementAmount',
					},
					{
						title: 'Purpose',
						dataIndex: 'purpose',
						key: 'purpose',
					},
					{
						title: 'No. of Payments',
						dataIndex: 'noOfPayments',
						key: 'noOfPayments',
					},
					{
						title: 'Status',
						dataIndex: 'status',
						key: 'status',
					},
				],
			});
		}
	}

	render() {
		return <PrintTable dataSource={this.state.dataSource} columns={this.state.columns} />;
	}
}

const mapStateToProps = state => ({
	...ContentPrinterDerivedStates(state.toJS())
});

export default connect(mapStateToProps, null)(ContentPrinter);
